module.exports = __webpack_public_path__ + "static/media/open orders.5199dcfd.svg";